export default {
  protocol: {},
  status: '',
  profile: {},
  token: localStorage.getItem('user-token') || ''
}



// WEBPACK FOOTER //
// ./src/store/state.js